import 'vue-toast-notification/dist/theme-sugar.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import VueCarousel from 'vue-carousel';
import VueMatchHeights from 'vue-match-heights';
import loader from "vue-ui-preloader";
import VueToast from 'vue-toast-notification';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap'
 
Vue.use(VueMatchHeights);
Vue.use(loader);
Vue.use(VueCarousel);
Vue.use(VueToast);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
